export function getBodyForSaveAndUpdateShortcutBackendApi(shortcutName, isDbs, selectedItemsObj, vaBfsList) {
  let {
    selectedDiscountPanelList, 
    selectedCustomPanelList, 
    selectedXChooseYPanelList,
    selectedTestList,
    selectedSeasonalPromoList
  } = selectedItemsObj;

  // bundles
  let bundles = [];
  selectedDiscountPanelList.concat(selectedCustomPanelList).forEach(panel => {
    let bundleType = panel.category === "discountPanel" ? "discountpanel" : "custompanel";
    bundles.push({
      bundle_id: panel.bundleId,
      bundle_name: panel.displayName || panel.bundleName || "",
      meta_data: {},
      bundle_type: bundleType
    });
  });
  selectedXChooseYPanelList.forEach(panel => {
    bundles.push({
      bundle_id: panel.bundleId,
      bundle_name: panel.displayName || panel.bundleName || "",
      meta_data: {
        selected_test_ids: panel.selectedZoomerIdList || [],
        supplement_test_ids: panel.selectedSupplementIdList || []
      },
      bundle_type: "xchoosey"
    });
  });

  // tests
  let tests = [];
  selectedTestList.forEach(test => {
    let testId, parentId;
    if (typeof test.id === "string") {
      [testId, parentId] = test.id.split("_");
      testId = parseInt(testId);
      parentId = parseInt(parentId);
    } else {
      testId = test.id;
      parentId = null;
    }
    let metaData = parentId ? { parent_id: parentId } : {};
    tests.push({
      test_id: testId,
      display_name: test.displayName || test.name || "",
      meta_data: metaData
    });
  });

  let shortcutBody = {
    shortcut_name: shortcutName,
    is_dbs: isDbs,
    bundles: bundles,
    tests: tests
  };
  return shortcutBody;
}

export function getShortcutForFrontend(shortcutName, price, id, isSelect, isDbs, selectedItemsObj) {
  let {
    selectedDiscountPanelList, 
    selectedCustomPanelList, 
    selectedXChooseYPanelList,
    selectedTestList,
    selectedSeasonalPromoList
  } = selectedItemsObj;
  let testIdsInSeasonalPromos = selectedSeasonalPromoList
    .reduce((acc, promo) => acc.concat([...promo.testIdsInPromo]), []);
  let testIdList = selectedTestList.map(test => test.id).concat(testIdsInSeasonalPromos);
  let shortcut = {
    shortcutName,
    testIdList,
    discountPanelIdList: selectedDiscountPanelList.map(panel => panel.bundleId),
    customPanelIdList: selectedCustomPanelList.map(panel => panel.bundleId),
    xChooseYIdList: selectedXChooseYPanelList.map(panel => {
      return { 
        bundleId: panel.bundleId,
        selectedZoomerIdList: panel.selectedZoomerIdList, 
        selectedSupplementIdList: panel.selectedSupplementIdList
      }
    }),
    price,
    category: "shortcut",
    id,
    isSelect,
    isDbs,
    isOpenShortcutDialog: false,
    needAction: false
  };
  return shortcut;
}